import React from 'react';
import ReactDOM from 'react-dom/client';

import './styles/index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';  // Import the ErrorBoundary component

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
